import { useState, useEffect } from 'react';
import DataTable from '../DataTable/DataTable';

const API = process.env.REACT_APP_API_URL;

export default function Customers({ showToast }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchCustomers(); }, []);

  const fetchCustomers = () => {
    setLoading(true);
    fetch(`${API}/customers`)
      .then(r => r.json())
      .then(data => { setRows(data); setLoading(false); })
      .catch(() => { showToast('Load Failed', 'Could not load customers.'); setLoading(false); });
  };

  return (
    <div>
      <div className="section-header">
        <div className="section-title">Customer Directory</div>
      </div>

      {loading ? (
        <p className="km-loading">Loading customers...</p>
      ) : (
        <DataTable
          columns={['# ID', 'Customer Name', 'Phone Number', 'Email Address']}
          initialRows={rows}
          renderRow={(row) => (
            <tr key={row.id}>
              <td className="td-id" style={{ width: '80px' }}>#{row.id}</td>
              <td style={{ fontWeight: '600' }}>{row.name}</td>
              <td>{row.phone || '—'}</td>
              <td className="td-muted">{row.email || '—'}</td>
            </tr>
          )}
        />
      )}
    </div>
  );
}